import {createSelector} from 'reselect';
import PaymentCategories from '../../../../enums/PaymentCategories';
import {isZeroValueOrder} from '../../selectors';
import getIsInApmExperimentWave3Variant1 from './getIsInApmExperimentWave3Variant1';
import getIsPaymentOptionAbovePaymentCategorySelectBoxesSelected
from './getIsPaymentOptionAbovePaymentCategorySelectBoxesSelected';
import getSelectedPaymentCategory from './getSelectedPaymentCategory';
import getShouldShowPaymentCategorySelectBoxes from './getShouldShowPaymentCategorySelectBoxes';

export default createSelector(
  [getIsInApmExperimentWave3Variant1, getIsPaymentOptionAbovePaymentCategorySelectBoxesSelected, getSelectedPaymentCategory, getShouldShowPaymentCategorySelectBoxes, isZeroValueOrder],
  (isInApmExperimentWave3Variant1, isPaymentOptionAbovePaymentCategorySelectBoxesSelected, selectedPaymentCategory, showPaymentCategorySelectBoxes, isZeroValueOrder) => {
    if (!isInApmExperimentWave3Variant1) {
      return false;
    }
    const hasCategorySelection = !!selectedPaymentCategory && selectedPaymentCategory !== PaymentCategories.NONE;
    const hasValidPaymentSelection = !showPaymentCategorySelectBoxes || hasCategorySelection || isPaymentOptionAbovePaymentCategorySelectBoxesSelected;
    return !isZeroValueOrder && !hasValidPaymentSelection;
  },
);
